(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["segastore-product-refinements"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const numericSize = (value) => {
      const normalized = String(value || '').replace(',', '.').trim();
      const match = normalized.match(/^(\d+(?:\.\d+)?)(?:\s*(?:UK|EU|US))?$/i);
      return match ? Number.parseFloat(match[1]) : Number.POSITIVE_INFINITY;
    };

    const sortSizeFieldsets = (root = document) => {
      root.querySelectorAll('variant-selects fieldset.product-form__input').forEach((fieldset) => {
        const legend = fieldset.querySelector(':scope > legend');
        if (!legend || !/\bsize\b/i.test(legend.textContent)) return;

        fieldset.dataset.segastoreSize = 'true';
        const inputs = Array.from(fieldset.querySelectorAll(':scope > input[type="radio"]'));
        const pairs = inputs.map((input) => {
          const label = fieldset.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          return { input, label, value: input.value || label?.textContent || '' };
        }).filter((pair) => pair.label);

        if (!pairs.every((pair) => Number.isFinite(numericSize(pair.value)))) return;

        const sorted = [...pairs].sort((a, b) => {
          const difference = numericSize(a.value) - numericSize(b.value);
          return Number.isFinite(difference) && difference !== 0
            ? difference
            : String(a.value).localeCompare(String(b.value), undefined, { numeric: true });
        });

        const alreadySorted = pairs.every((pair, index) => pair.input === sorted[index]?.input);
        if (alreadySorted) return;

        const fragment = document.createDocumentFragment();
        sorted.forEach(({ input, label }) => {
          fragment.append(input, label);
        });
        fieldset.append(fragment);
      });

      root.querySelectorAll('variant-selects .product-form__input--dropdown').forEach((wrapper) => {
        const label = wrapper.querySelector(':scope > .form__label');
        const select = wrapper.querySelector('select');
        if (!label || !select || !/\bsize\b/i.test(label.textContent)) return;

        const options = Array.from(select.options);
        if (!options.every((option) => Number.isFinite(numericSize(option.textContent)))) return;
        const sorted = [...options].sort((a, b) => {
          const difference = numericSize(a.textContent) - numericSize(b.textContent);
          return Number.isFinite(difference) && difference !== 0
            ? difference
            : a.textContent.localeCompare(b.textContent, undefined, { numeric: true });
        });
        if (options.every((option, index) => option === sorted[index])) return;
        sorted.forEach((option) => select.append(option));
      });
    };

    const titleCaseInterfaceCopy = (root = document) => {
      const replacements = new Map([
        ['Write a review', 'Write a Review'],
        ['Ask a question', 'Ask a Question'],
        ['Sort by', 'Sort By'],
        ['Most recent', 'Most Recent'],
        ['Highest rating', 'Highest Rating'],
        ['Lowest rating', 'Lowest Rating'],
        ['Key features', 'Key Features'],
        ['Use and care', 'Use & Care'],
        ['Fit and care', 'Fit and Care']
      ]);

      root.querySelectorAll('.jdgm-widget button, .jdgm-widget a, .jdgm-widget option, .jdgm-widget label, .jdgm-widget span, .product__description h2, .product__description h3').forEach((element) => {
        const current = element.textContent.trim();
        if (element.childElementCount === 0 && replacements.has(current)) element.textContent = replacements.get(current);
        if ('value' in element && replacements.has(element.value)) element.value = replacements.get(element.value);
      });

      root.querySelectorAll('.segastore-assurance h2').forEach((heading) => {
        const current = heading.textContent.trim();
        const warranty = current.match(/^(\d+)\s+(month|year)s?\s+warranty$/i);
        if (warranty) {
          const unit = warranty[2].charAt(0).toUpperCase() + warranty[2].slice(1).toLowerCase();
          heading.textContent = warranty[1] + '-' + unit + ' Warranty';
        }
      });
    };

    let queued = false;
    const enhanceProductPage = (root = document) => {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(() => {
        queued = false;
        sortSizeFieldsets(root);
        titleCaseInterfaceCopy(root);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => enhanceProductPage());
    } else {
      enhanceProductPage();
    }

    document.addEventListener('shopify:section:load', (event) => enhanceProductPage(event.target));

    const productRoot = document.querySelector('#MainContent');
    if (productRoot) {
      const relevantSelector = '.product__info-container, #judgeme_product_reviews, .jdgm-widget';
      const observer = new MutationObserver((mutations) => {
        const hasRelevantChange = mutations.some((mutation) => {
          if (mutation.target instanceof Element && mutation.target.closest(relevantSelector)) return true;
          return Array.from(mutation.addedNodes).some(
            (node) => node instanceof Element && (node.matches(relevantSelector) || node.querySelector(relevantSelector))
          );
        });
        if (hasRelevantChange) enhanceProductPage(productRoot);
      });
      observer.observe(productRoot, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["segastore-trust-bar"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('focusin', (event) => {
    const item = event.target.closest('.segastore-trust__headline');
    if (!item) return;
    item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
  });

  } catch(e) { console.error(e); }
})();
})();
